import {
  toModalFields,
  getAlwaysDisabledFields,
} from '../../../domains/therapeutic-areas/adapters';

// Use adapters for therapeutic area fields
export const therapeuticAreaFields = toModalFields();
export const therapeuticAreaAlwaysDisabledFields = getAlwaysDisabledFields();
